import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import loadable from '../../../../utils/loadable';

import { setWatchlistLoadStatus } from '../../../../actions/watchlistActions';

import Styles from './styles.module.scss';

const Sectors = loadable(() => import('../../../SEO_pages/SectorsTab'));

const SectorsTab = ({ topic }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setWatchlistLoadStatus('LOADED'));
  }, []);

  return (
    <div className={Styles['sectors-tab']}>
      <Sectors slug={topic} />
    </div>
  );
};

export default SectorsTab;
